
export const content = {
  title: "Digitális tartalmak",
  details: {
    backToContent: "Vissza a tartalmakhoz",
    purchase: "Megvásárolom",
    downloadNow: "Letöltés most"
  },
  loading: "Tartalom betöltése...",
  backToList: "Vissza a tartalomlistához",
  requestForm: {
    title: "Milyen digitális tartalmat szeretnél látni?",
    description: "Ha van olyan tartalom, amit szívesen látnál, írd meg nekünk és igyekszünk megvalósítani!",
    placeholder: "Pl.: Szeretnék egy vicces emoji csomagot...",
    submit: "Küldés",
    sent: "Elküldve!"
  }
};
